import script from "./StreamingDemo.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamingDemo.vue?vue&type=script&setup=true&lang=js"

import "./StreamingDemo.vue?vue&type=style&index=0&id=190a0eb4&scoped=true&lang=css"

import exportComponent from "/home/artur/Documents/bemyvega-gitlab/platform-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-190a0eb4"]])

export default __exports__